import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../styles/HomePage.css";
import useHomeData from "../hooks/useHomeData";
import useSloganPart from "../hooks/useSloganPart";
import Herobanner from "../components/HeroBanner";
import SloganPart from "../components/SloganPart";
import LivetheArt from "../components/LivetheArt";
import ShopBy from "../components/ShopBy";
import BestsellersSlider from "../components/BestsellersSlider";
import SaleoOnTheTable from "../components/SaleoOnTheTable";
import PromoSection from "../components/PromoSection";
import CarpetforEverySpot from "../components/CarpetforEverySpot";
import LetsFindYourFloor from "../components/LetsFindYourFloor";
import ObsessedRightNow from "../components/ObsessedRightNow";
import ObsessionsinAction from "../components/ObsessionsinAction";
import OurObsessions from "../components/OurObsessions";
import Footer from "../../../components/Footer/Footer";
import ProductQuickViewModal from "../../quickView/pages/ProductsQuickViewModal";
import LivetheArtMobile from "../components/LivetheArtMobile";

const HomePage = () => {
  const location = useLocation();
  const { items, currentIndex, fade } = useSloganPart();
  const { data, loading } = useHomeData();
  const [showModal, setShowModal] = useState(false);
  const [quickViewProduct, setQuickViewProduct] = useState(null);

  const handleQuickView = (product) => {
    setQuickViewProduct(product);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  // Initial load
  useEffect(() => {
    document.body.style.overflow = "auto";
    window.scrollTo({ top: 0 });
  }, []);

  // FIXED SCROLL LOGIC
  useEffect(() => {
    document.body.style.overflow = "auto";

    if (location.state?.scrollTo) {
      const timer = setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);

        if (el) {
          const yOffset = -80; // adjust if header exists
          const y =
            el.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;

          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }
      }, 400); // ensures DOM fully loaded

      return () => clearTimeout(timer);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location.state]);

  // Loading UI
  if (loading) {
    return (
      <div className="homepage-loader">
        <p>Loading homepage...</p>
      </div>
    );
  }

  const safeData = data || {};

  return (
    <>
      <Herobanner data={safeData} />
      <SloganPart items={items} currentIndex={currentIndex} fade={fade} />
      <div className="LivethartDesktop">
          <LivetheArt />
      </div>
      <div className="LivethartMobile">
          <LivetheArtMobile />
      </div>
      <ShopBy />
      <BestsellersSlider onQuickView={handleQuickView} />
      <SaleoOnTheTable />
      <PromoSection />
      <CarpetforEverySpot />
      <LetsFindYourFloor />
      <ObsessedRightNow />
      <ObsessionsinAction />
      <div id="our-obsessions"> </div>
      <OurObsessions />
      <ProductQuickViewModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          document.body.style.overflow = "auto";
        }}
        product={quickViewProduct}
      />
      <Footer />
    </>
  );
};
export default HomePage;